import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { updatedArticleLabelPrintRoutes } from './updated-article-label-print.routes';
import { SOFTLINE_PERMISSION_UPDATED_ARTICLE_LABEL_PRINT } from './updated-article-label-print.permissions';

export const updatedArticleLabelPrintProviders: Array<EnvironmentProviders | Provider> = [
  provideSoftAppsModule(
    {
      name: '#UPDATED_ARTICLE_LABEL_PRINT.TITLE',
      title: '#UPDATED_ARTICLE_LABEL_PRINT.TITLE',
      icon: 'fa-regular fa-print',
      route: '/updated-article-label-print',
      permission: SOFTLINE_PERMISSION_UPDATED_ARTICLE_LABEL_PRINT,
      group: getModuleGroupByName('Warenwirtschaft'),
    },
    withSoftAppsModuleRoutes({ app: updatedArticleLabelPrintRoutes }),
    withSoftAppsModuleTranslation({ de }),
    withSoftAppsModuleInfo({
      library: '@softapps/wws/updated-article-label-print',
      description: 'Etikettendruck für geänderte Artikel.',
    })
  ),
];
